module.exports = __webpack_public_path__ + "img/9788979869620.61782352.jpg";